export default __webpack_public_path__ + "static/media/image14.d2720db5.jpg";